<template >
    <InfoContainer :infoTitle="infoConConfig['infoTitle']" :contentConfig="infoConConfig['infoContent']"
        class="comment-container">
        <template #projectInfo>
            <a-descriptions class="label_wrapper" border :column="2">
                <a-descriptions-item label="项目编号">{{ formatter(dataInfo.number) }}</a-descriptions-item>
                <a-descriptions-item label="项目名称">{{ formatter(dataInfo.projectName) }}</a-descriptions-item>
                <a-descriptions-item label="项目类型">{{ dictionaryLabel(dataInfo.projectType, dictionaryData.zsProjectTypeList)
                }}</a-descriptions-item>
                
                <!-- projectType：4  类型为人才项目时，右侧的投资规模变成“人才类型” -->
                <a-descriptions-item label="人才类型" v-if="dataInfo.projectType==4
                ">{{ dictionaryLabel(dataInfo.talentType, dictionaryData.zsTalentTypeList)
                }}</a-descriptions-item>

                <a-descriptions-item label="投资规模" v-else>{{ formatter(dataInfo.investScale,'亿元')
                }}</a-descriptions-item>


                <a-descriptions-item label="申报人">{{ formatter(dataInfo.createUserName) }}</a-descriptions-item>
                <a-descriptions-item label="投资方">{{ formatter(dataInfo.investor) }}</a-descriptions-item>
                <a-descriptions-item label="建议落地">{{ dictionaryLabel(dataInfo.projectLanding, dictionaryData.zsLandingAreaList)
                }}</a-descriptions-item>
                <a-descriptions-item label="申报时间">{{ formatter(dataInfo.updateTime) }}</a-descriptions-item>
                <a-descriptions-item label="申报部门" :span="2">{{ formatter(dataInfo.createDeptName) }}</a-descriptions-item>
                
                <a-descriptions-item label="对接联系人" :span="2">
                    <div class="person_wrapper">
                            <div v-if="dataInfo.contactPersonList.length > 0" v-for="(item) in dataInfo.contactPersonList" :key="item.id" class="person-con">
                            <div class="person-item flex-con">
                                <span class="person-item-title">{{ `${item.name}/${item.phone}/${item.job}` }}</span>
                            </div>
                            </div>
                    </div>
                    

                </a-descriptions-item>
                <a-descriptions-item label="项目概览" :span="2">{{ formatter(dataInfo.projectOverview) }}</a-descriptions-item>
                <a-descriptions-item label="项目诉求" :span="2">{{ formatter(dataInfo.projectDemands) }}</a-descriptions-item>
                <a-descriptions-item label="对接情况" :span="2">{{ formatter(dataInfo.contactSituation) }}</a-descriptions-item>
                <a-descriptions-item label="补充内容" :span="2">{{ formatter(dataInfo.additionalContent) }}</a-descriptions-item>
                <a-descriptions-item label="意见建议" :span="2">{{ formatter(dataInfo.advice) }}</a-descriptions-item>
                <a-descriptions-item label="附件信息" :span="2">
                     <Accessory
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(153, 153, 153, 0.8)"        
                        :projectid="dataInfo.id"
                        :dynamicId="dataInfo.id"
                        fileMenuUrlname="数字化招商平台"
                        idname="项目申报"
                        :upload="false"
                        />

                </a-descriptions-item>
            </a-descriptions>
        </template>
    </InfoContainer>
</template>
  <!-- 
   *  <ProjectInfo :dataInfo="dataInfo" />
   *  dataInfo 项目信息  Object
   *
   *

   -->
<script >
import util from "@/mixins/util";
import FrameWrapper from "@/components/frame/zsFrame"
import InfoContainer from "@/components/infoContainer/zsInfoContainer";
import { validatenull } from "@/util/validate";
import Accessory from "@/components/accessoriesother/accessoryFactor";

export default {
    name: "projectInfo",
    mixins: [util],
    data() {
        return {
            infoConConfig: {
                infoTitle: "项目信息",
                infoContent: [
                    {
                        title: "",
                        prop: "projectInfo",
                    },
                ],
            },
            dictionaryData:{

            }
        }
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return {
                    contactPersonList:[]
                }
            },
        },
    },
    components: {
        InfoContainer,
        FrameWrapper,
        Accessory
    },
    computed:{

        formatter(){
            return function(field,unit){
                return validatenull(field)?'/':field+(validatenull(unit)?'':unit)
            }
        }
    },
    async mounted() {
        let dataList = [
            { code: "zs_project_type", name: "zsProjectTypeList" },
            { code: "zs_project_status", name: "zsProjectStatusList" },
            { code: "zs_landing_area", name: "zsLandingAreaList" },
            { code: "zs_talent_type", name: "zsTalentTypeList" },
            
        ];
        let dictionaryData = await this.dictionaryAllMap(dataList);
        this.dictionaryData = dictionaryData
    },
    methods: {
        validatenull
    },
};
</script>
  
<style lang="scss" scoped>
.content_slot {
    padding: 20px 1rem;
}
.person_wrapper {
    display: grid;
}
/deep/.ant-descriptions-item .ant-descriptions-item-label {
    color: #999999;
    font-weight: 400;
}

/deep/.ant-descriptions-item .ant-descriptions-item-content {
    color: #333333;
    font-weight: 400;
}
</style>